export default __webpack_public_path__ + "static/media/gallery01.00e7027b.jpg";